/* eslint-disable react-hooks/exhaustive-deps */
import { ANIMATED_STYLE } from "src/libs/interfaces/animated"
import { CARD_ANIMATE_DELAY, ILandingSection, ITableRCell, ITableRow, SELECT_TYPE, TableContent } from "src/modules/pe-landing-module/data/interfaces"
import { getAnimateDelay } from "../../../utils/getAnimateDelay"
import { useEffect, useRef } from "react"
import { useAnimated } from "src/modules/pe-landing-module/hooks/useAnimated"
import { useAnimatedStyle } from "src/modules/pe-landing-module/hooks/useAnimatedStyle"
import TextBlock from "../../useful/TextBlock"
import TableCellEditor from "../../landing-edit/table/TableCellEditor"
import { getContrastColor } from "src/libs/utilities"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"

interface ITableCellProps {
    section?: ILandingSection
    table: TableContent
    cell: ITableRCell,
    row: ITableRow
    i: number
    rowOrder:number
    animated?: ANIMATED_STYLE
    animated_delay?: CARD_ANIMATE_DELAY | string | number
    
}
const TableCell  = ({ table, cell, i, row, animated, animated_delay, ...props }: ITableCellProps): JSX.Element => { 
    const _animated_delay = getAnimateDelay( animated_delay, i)
    const ref = useRef(null)
    useAnimated( ref, _animated_delay )
    const animate   = useAnimatedStyle(row, i)
    useEffect(() => {
        addCSSClass(
            `table-cell-${table.id}-${cell.id}`,
            `
            .table-cell-${table.id}-${cell.id} {
                background-color: ${cell.bg};
                color: ${!!cell.color 
                    ? 
                    cell.color 
                    : 
                    !!cell.bg 
                        ? 
                        getContrastColor(cell.bg) 
                        : 
                        undefined}; 
                border-color: ${cell.border?.borderColor}!important;
                border-width: ${cell.border?.borderWidth}px!important;
            }`
        )
        return () => {
            removeCSSClass( `table-cell-${table.id}-${cell.id}` )
        }
    }, [] ) 
     return <td ref={ref} className={` ${animate} table-cell-${table.id}-${cell.id} `}  colSpan={cell.colSpan} rowSpan={cell.rowSpan} id={cell.id.toString()}>
        <TableCellEditor cell={cell} table={table} section={ props.section || {} as ILandingSection } >
            <TextBlock 
                editType={ SELECT_TYPE.TABLE_TD }
                section={ props.section || {} as ILandingSection}
                data={ { table, cell, i, row, animated, animated_delay, ...props } } 
                columns={ 1 }
                text={ cell.text }
                data-select-type="ignore"
            />
        </TableCellEditor>
    </td>
}
export default TableCell

